import React from 'react'
import { graphql, compose } from 'react-apollo'
import gql from 'graphql-tag'
import {
  constructQueryForTerms,
  constructTermsObj
} from 'utils/constructQuery'
import toURLParams from 'utils/toURLParams'
import { KontaktiRezultati, Rezultati } from 'pages'

const withTermsQuery = (postType, termsArray, lang, tekstiArray, items_perpage = 10, orderby = 'date_created', order = 'desc') => {
  const ITEMS_PER_PAGE = items_perpage

  const persistFilterStateKey = '_rezultati_filterState'
  const initialFilterState = {
    page: 0,
    total: 0
  }

  const _getInitialFilterState = () => {
    // IMPORTANT: 2. posms izņemts, jo rada nevēlamas situācijas, kad pēc navigācijas
    // iegūstam atfiltrētu sarakstu, jo sessionStorage ir glabājis filterState.

    // NOTE: Primāri pārbaudam location.search parametrus, ja to nav, tad mēģinam
    // iegūt filtru state no sessionStorage vai atgriežam initialFilterState.

    const persistFilterState = Object.assign({}, initialFilterState)

    if (typeof window !== 'undefined') {
      const { search } = window.location
      if (search && 'URLSearchParams' in window) {
        const searchParams = new URLSearchParams(search)

        searchParams.forEach((value, key) => {
          if (key === 'page' || key === 'perpage') {
            persistFilterState[key] = parseInt(value, 10)
          } else if (key === 'search') {
            persistFilterState[key] = value
          } else if (termsArray.includes(key)) {
            if (value !== 'null') {
              persistFilterState[key] = value.split(',')
            }
          } else if (key === 'from' || key === 'to') {
            persistFilterState[key] = parseInt(value, 10)
          }

          if (value === 'null') {
            delete persistFilterState[key]
          }
        })
      }
    }

    return persistFilterState
  }

  const persistedFilterState = _getInitialFilterState()

  const QUERY = gql(
    constructQueryForTerms(
      postType,
      termsArray,
      tekstiArray
    )
  )

  const queryOptions = {
    options: props => ({
      fetchPolicy: 'cache-first',
      variables: Object.assign({},
        {
          lang: (lang || 'lv'),
          page: persistedFilterState.page || 0,
          perpage: ITEMS_PER_PAGE,
          orderby,
          order,
          search: persistedFilterState.search || props.search || null,
          from: persistedFilterState.from || null,
          to: persistedFilterState.to || null
        },
        constructTermsObj(termsArray, persistedFilterState)
      )
    }),
    props: ({ data }) => ({
      [postType]: data[postType],
      loading: data.loading,
      refetch: data.refetch,
      teksti: data.teksti
    })
  }

  class TermsPage extends React.PureComponent {
    constructor(props) {
      super(props)
      this.state = _getInitialFilterState()
    }

    // NOTE: Pagination scroll
    componentDidMount() {
      window.scrollTo(0, 0)
    }
    componentDidUpdate() {
      window.scrollTo(0, 0)
    }

    _refetch = () => {
      try {
        sessionStorage.setItem(persistFilterStateKey, JSON.stringify(this.state))
      } catch (error) {
        // error
      }

      if (this.state.search) {
        window.gtag && gtag('event', 'search', {
          event_label: postType,
          search_term: this.state.search
        })
      }

      const filteredState = this.removeKeys(this.state, ['total'])
      const search = toURLParams(filteredState)
      const { history } = this.props
      history.push({
        search
      })

      const refetchVariables = Object.assign({},
        {
          lang: this.props.lang,
          page: this.state.page,
          perpage: ITEMS_PER_PAGE
        },
        constructTermsObj(termsArray, this.state), {
          search: this.state.search,
          from: this.state.from,
          to: this.state.to
        }
      )
      this.props.refetch(refetchVariables)
    }

    removeKeys = (obj, keysArr) => {
      let filteredObj = {}
      for (const [key, value] of Object.entries(obj)) {
        if (!keysArr.includes(key)) {
          filteredObj[key] = value
        }
      }
      return filteredObj
    }

    // FIXME: event nav nepieciešams, arg un value.. wtf
    _filter = (event, arg, value) => {
      if (event) {
        event.preventDefault()
      }
      let { [arg]: terms } = this.state
      if (value) {
        if (terms) {
          if (typeof terms === 'object') {
            if (terms.indexOf(value) < 0) {
              terms = [...terms, value]
            } else {
              terms = terms.filter(i => i !== value) || null
            }
          }
        } else {
          terms = [value]
        }
      } else {
        terms = null
      }

      // NOTE: Ja nepieciešams deaktivizēt filtru,
      // tukšs masīvs nedarbojas, tāpēc izmantojam null.
      if (Array.isArray(terms) && !terms.length) {
        terms = null
      }

      this.setState(prevState => Object.assign({}, prevState, {
        page: 0,
        [arg]: terms
      }), this._refetch)
    }

    _filterByKeywords = value => {
      this.setState(prevState => Object.assign({}, prevState, {
        page: 0,
        search: value
      }), this._refetch)
    }

    _filterByDate = (from, to) => {
      this.setState(prevState => Object.assign({}, prevState, {
        page: 0,
        from,
        to
      }), this._refetch)
    }

    _paginate = page => {
      if (!Number.isNaN(page) && page !== this.state.page) {
        this.setState(prevState => Object.assign({}, prevState, {
          page
        }), this._refetch)
      }
    }

    render() {
      const {
        loading,
        lang,
        teksti,
        init_page,
        ...rest
      } = this.props

      const data = {
        postType,
        postsData: this.props[postType],
        termsArray,
        lang,
        teksti,
        init_page,
        filter: this._filter,
        filterState: this.state,
        filterByKeywords: this._filterByKeywords,
        filterByDate: this._filterByDate,
        perpage: ITEMS_PER_PAGE,
        paginate: this._paginate
      }

      return loading ? null : (
          postType === 'pasvaldibas_kontakti' ?
            <KontaktiRezultati
              {...data}
              initialFilterState={rest.initialFilterState}
            /> :
            <Rezultati {...data} />
      )
    }
  }

  return compose(
    graphql(QUERY, queryOptions)
  )(TermsPage)
}

export default withTermsQuery



// WEBPACK FOOTER //
// ./src/utils/withTermsQuery.js